import { useEffect, useMemo } from 'react';

import Confetti from './Confetti.jsx';

const DURATION_MS = 2600;

/**
 * Fires the confetti burst and a green pill toast when a ticket transitions
 * to "resolved". Mount this in the page tree with `active=true` when the
 * transition succeeds; it self-dismisses after DURATION_MS via `onDone`.
 *
 * Respects prefers-reduced-motion: skips the canvas animation and just
 * shows the toast for accessibility.
 */
export default function Celebration({ active, onDone }) {
  const reducedMotion = useMemo(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return false;
    }
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }, []);

  useEffect(() => {
    if (!active) return undefined;
    const timer = setTimeout(() => onDone?.(), DURATION_MS);
    return () => clearTimeout(timer);
  }, [active, onDone]);

  if (!active) return null;

  return (
    <>
      {!reducedMotion && <Confetti />}
      <div
        className="celebration-toast"
        role="status"
        aria-live="polite"
      >
        Ticket resolved! 🎉
      </div>
    </>
  );
}
